module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_SOL_MEGALITH_MEGABROWN.33865a68.webp";